export interface ProductCardSizeConfig {
  imageSize: number;
  titleFontSize: string;
  descriptionFontSize: string;
  priceFontSize: number;
  padding: string;
  borderRadius: number;
  gap: number;
  background: string;
  imageBorderRadius: number;
}

export const PRODUCT_CARD_SIZES: Record<string, ProductCardSizeConfig> = {
  small: {
    imageSize: 120,
    titleFontSize: "16px",
    descriptionFontSize: "12px",
    priceFontSize: 16,
    padding: "8px",
    borderRadius: 2.5,
    gap: 0.5,
    background: "background.paper",
    imageBorderRadius: 2,
  },
  medium: {
    imageSize: 200,
    titleFontSize: "16px",
    descriptionFontSize: "12px",
    priceFontSize: 16,
    padding: "10px",
    borderRadius: 2.5,
    gap: 0.75,
    background: "background.paper",
    imageBorderRadius: 2,
  },
  large: {
    imageSize: 320,
    titleFontSize: "18px",
    descriptionFontSize: "14px",
    priceFontSize: 16,
    padding: "12px",
    borderRadius: 3,
    gap: 1,
    background: "background.paper",
    imageBorderRadius: 2.5,
  },
  xlarge: {
    imageSize: 400,
    titleFontSize: "20px",
    descriptionFontSize: "16px",
    priceFontSize: 16,
    padding: "16px",
    borderRadius: 3.5,
    gap: 1.25,
    background: "background.paper",
    imageBorderRadius: 3,
  },
};

export const getProductCardConfig = (size: string): ProductCardSizeConfig => {
  return PRODUCT_CARD_SIZES[size] || PRODUCT_CARD_SIZES.medium;
};
